import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UtilService } from '@service/util/util.service';
import { RestService } from 'cargo-chief-commons';
import { UrlService } from '@service/url/url.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';

@Component({
	selector: 'app-move-contact',
	templateUrl: './move-contact.component.html',
	styleUrls: ['./move-contact.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class MoveContactComponent implements OnInit {
	@Input() carrier;
	@Input() contactId;

	constructor(
		private restService: RestService,
		private urlService: UrlService,
		private utilService: UtilService,
		public dialog: MatDialog
	) {}

	ngOnInit() {}

	openMoveContactForm() {
		const dialogRef = this.dialog.open(MoveContactDialog, {
			width: '650px',
			data: {
				carrier: this.carrier,
				contactId: this.contactId,
			},
		});
	}
}

@Component({
	selector: 'app-move-contact-dialog',
	templateUrl: 'modal.template.html',
})
export class MoveContactDialog {
	isRequestInProgress = false;
	mc = '';

	constructor(
		public dialogRef: MatDialogRef<MoveContactDialog>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private urlService: UrlService,
		private restService: RestService,
		private utilService: UtilService
	) {}

	moveContact() {
		this.isRequestInProgress = true;
		const payload = {
			mc: this.mc,
			contactId: this.data.contactId,
		};
		const url = this.urlService.moveCarrierContact();
		this.restService.POST(url, payload).subscribe(
			(result) => {
				this.utilService.showSnackbar(
					'Contact moved to carrier Successfully.',
					SNACKBAR.SUCCESS,
					SNACKBAR.ACTION
				);
				this.closeDialog();
			},
			(error) => {
				this.utilService.showSnackbar(
					'Unable to move contact now. Please try again later.',
					SNACKBAR.ERROR,
					SNACKBAR.ACTION
				);
			}
		);
	}

	closeDialog(): void {
		this.dialogRef.close();
	}
}
